/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  BitcoinSafeOwner,
  BitcoinSafeOwnerInterface,
} from "../../../contracts/v1.0.0-beta.3/BitcoinSafeOwner";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "ContractAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "EmergencyGovernanceAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidEmergencyGovernanceCaller",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNewSingletonAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignatureLength",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignatureS",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignatureV",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTruncatedBitcoinAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUpgradeInitData",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUpgradeSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "PubkeyNotOnCurve",
    type: "error",
  },
  {
    inputs: [],
    name: "SingletonAlreadyUpgraded",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldSingleton",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
    ],
    name: "SingletonUpgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADE_SINGLETON_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyGovernance",
    outputs: [
      {
        internalType: "contract EmergencyGovernance",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "initData",
        type: "bytes",
      },
    ],
    name: "emergencyUpgradeSingleton",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "isValidSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "magicValue",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "isValidSignature",
    outputs: [
      {
        internalType: "bytes4",
        name: "magicValue",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes20",
        name: "_truncatedBitcoinAddress",
        type: "bytes20",
      },
      {
        internalType: "address",
        name: "_emergencyGovernance",
        type: "address",
      },
    ],
    name: "setup",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "truncatedBitcoinAddress",
    outputs: [
      {
        internalType: "bytes20",
        name: "",
        type: "bytes20",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "initData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "upgradeSingleton",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BitcoinSafeOwnerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BitcoinSafeOwnerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BitcoinSafeOwner__factory extends ContractFactory {
  constructor(...args: BitcoinSafeOwnerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      BitcoinSafeOwner & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): BitcoinSafeOwner__factory {
    return super.connect(runner) as BitcoinSafeOwner__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BitcoinSafeOwnerInterface {
    return new Interface(_abi) as BitcoinSafeOwnerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): BitcoinSafeOwner {
    return new Contract(address, _abi, runner) as unknown as BitcoinSafeOwner;
  }
}
